import { render, staticRenderFns } from "./VisualizacionPopularidadIndustria.vue?vue&type=template&id=22cf9eee&scoped=true&"
import script from "./VisualizacionPopularidadIndustria.vue?vue&type=script&lang=js&"
export * from "./VisualizacionPopularidadIndustria.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionPopularidadIndustria.vue?vue&type=style&index=0&id=22cf9eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf9eee",
  null
  
)

export default component.exports